import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import type { CellValue } from 'ksnm-common-ui/lib/Table2/Table.interface';
import type { ReactChild, ReactElement } from 'react';

import styles from './Status.module.scss';

const colorByStatus = {
  n: '#9EB3C8',
  s: '#58bf7f',
  w: '#EE6C4D',
};

export const Status = ({ children, status }: { children: ReactChild; status?: CellValue }): ReactElement => (
  <div className={styles.status}>
    {status && typeof status === 'string' && status !== 'e' && (
      <div className={styles.circle} style={{ backgroundColor: colorByStatus[status] }} />
    )}
    {status && status === 'e' && <Icon name="stop" fill="#EE6C4D" />}
    {children}
  </div>
);
